import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import EditorSidebar from './EditorSidebar'
import { changeEditorScene } from 'actions/locationAC'
import { getTemplateByApp, getTemplateInfo } from 'templates/templates'
import * as templateCategory from 'constants/templateCategory'
import * as editorModes from 'constants/editorMode'


class EditorSidebarContainer extends Component {

  onChangeScene = (index) => {
    const { dispatch, location } = this.props
    if (index !== location.sceneNum) {
      dispatch(changeEditorScene(index))
    }
  }

  render () {
    if (this.props.editorMode === editorModes.EDIT) {
      const { app, location } = this.props
      const template = getTemplateByApp(app)
      const customFieldsConf = template.customFields
      const templateInfo = getTemplateInfo(app.templateId)
      // the sidebar is not visible in the instagram editor from the second scene
      if (templateInfo.category === templateCategory.INSTAGRAM_SHOPPABLE && location.sceneNum > 1) return null

      return (
        <EditorSidebar
          scenes={customFieldsConf}
          selectedSceneNum={location.sceneNum}
          changeScene={this.onChangeScene}
          app={app}
          settings={template.settings}
        />
      )
    } else {
      return null
    }
  }
}

EditorSidebarContainer.propTypes = {
  app: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  editorMode: PropTypes.string
}

const mapStateToProps = (state) => ({
  location: state.location,
})

export default connect(mapStateToProps)(EditorSidebarContainer)



// WEBPACK FOOTER //
// ./src/components/editor/sidebar/EditorSidebarContainer.js